"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketRuleCondition = void 0;
const market_rule_base_1 = require("./market-rule-base");
class MarketRuleCondition extends market_rule_base_1.MarketRuleBase {
    /**
     * Constructor
     * @param obj Source object for fields initialiazation
     */
    constructor(obj) {
        super(obj);
        if (obj) {
            this.operator = obj.operator;
        }
    }
}
exports.MarketRuleCondition = MarketRuleCondition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0LXJ1bGUtY29uZGl0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2NvbnRlbnQvaGlzdG9yaWNhbC1wcmljaW5nL3RpbWUtc2VyaWVzL3NlcnZpY2VzL3J1bGUtZW5naW5lLXNlcnZpY2UvY2xhc3Nlcy9tYXJrZXQtcnVsZS1jb25kaXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EseURBQW9EO0FBRXBELE1BQXNCLG1CQUFvQixTQUFRLGlDQUFjO0lBRzVEOzs7T0FHRztJQUNILFlBQW1CLEdBQWtDO1FBQ2pELEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUVYLElBQUksR0FBRyxFQUFFLENBQUM7WUFDTixJQUFJLENBQUMsUUFBUSxHQUFHLEdBQUcsQ0FBQyxRQUFTLENBQUM7UUFDbEMsQ0FBQztJQUNMLENBQUM7Q0FDSjtBQWRELGtEQWNDIn0=